// WP-1.12 (SR-1, S-37 `/search`): one query hook over the global search route.
import { searchResponseSchema, type SearchResult } from '@pfos/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api';

export const SEARCH_KEY = ['search'] as const;

export function useSearch(query: string, limit = 20): UseQueryResult<SearchResult[]> {
  const trimmed = query.trim();
  return useQuery({
    queryKey: [...SEARCH_KEY, trimmed, limit],
    queryFn: async () => {
      const params = new URLSearchParams({ q: trimmed, limit: String(limit) });
      const body = searchResponseSchema.parse(await api.get(`/api/v1/search?${params.toString()}`));
      return body.results;
    },
    enabled: trimmed !== '',
  });
}
